import { render, staticRenderFns } from "./RDashboardTypeCard.vue?vue&type=template&id=509fa54c&scoped=true&"
import script from "./RDashboardTypeCard.vue?vue&type=script&lang=js&"
export * from "./RDashboardTypeCard.vue?vue&type=script&lang=js&"
import style0 from "./RDashboardTypeCard.vue?vue&type=style&index=0&id=509fa54c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509fa54c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardTitle,VImg})
